import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _actions from '../../actions';
import ImageDropZone from '../common/ImageDropZone';
import constants from '../../constants';
import ImageCropper from '../common/imageCropper';
import ValidatedInput from '../forms/ValidatedInput';
import ColorRadio from '../forms/ColorRadio';
import i18n from '../../i18n';
import TapTypeSelector from './TapTypeSelector';
import LargeLoading from '../svg/LargeLoading';

class BannerContentEditor extends Component {
    constructor(props) {
        super(props);
        this.setFile = this.setFile.bind(this);
        this.switchToSizes = this.switchToSizes.bind(this);
        this.switchToCrop = this.switchToCrop.bind(this);
        this.switchToUpload = this.switchToUpload.bind(this);
        this.recropImage = this.recropImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.state = {
            file: '',
            cropperView: 0,
            hasError: false,
        };
    }

    componentDidMount() {
        if (this.props.contentModalContent.imageUrl.length > 1) {
            this.switchToSizes();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.crop.modal !== prevProps.crop.modal && this.props.crop.modal === true) {
            this.switchToCrop();
        } else if (this.props.crop.hasCroppedImage !== prevProps.crop.hasCroppedImage
            || this.props.crop.wrongResolution !== prevProps.crop.wrongResolution) {
            if (this.props.crop.hasCroppedImage === false
                && this.props.crop.wrongResolution === true) {
                this.displayWarning();
            } else if (this.props.crop.hasCroppedImage === false
                && this.props.crop.wrongResolution === false) {
                this.switchToUpload();
            } else if (this.props.crop.hasCroppedImage === true) {
                this.switchToSizes();
            }
        }
        if (prevState.cropperView === 0 && this.props.crop.hasCroppedImage) {
            this.switchToSizes();
        }
        if (prevState.cropperView === 1
            && this.state.cropperView !== 1
            && this.props.crop.hasCroppedImage === false) {
            if (this.props.contentModalContent.imageUrl.length < 1) {
                this.switchToUpload();
            } else {
                this.switchToSizes();
            }
        }
    }

    componentWillUnmount() {
        this.props.actions.resetImageData();
        this.props.actions.clearAlert('content-banner-wrong-size');
        this.props.actions.clearAlert('pages-modal-upload-wrong-type');
        this.props.actions.clearAlert('pages-modal-upload-wrong-file-size');
    }

    setFile(file) {
        this.setState({ file, hasError: false });
    }

    displayWarning() {
        const alertMessage = `${i18n.t('logo.error1')} ${constants.ImageType.find((n) => { return n.Name === 'ContentBanner'; }).MinWidth} px x ${constants.ImageType.find((n) => { return n.Name === 'ContentBanner'; }).MinHeight} px`;
        this.setState({ hasError: true });
        this.props.actions.addAlert({
            message: alertMessage,
            dismissable: true,
            type: 'error',
            view: 'pages-modal',
            id: 'content-banner-wrong-size',
        });
    }

    switchToSizes() {
        this.setState({
            cropperView: 2,
        });
    }

    switchToCrop() {
        this.setState({
            cropperView: 1,
            originalHeight: 0,
            originalWidth: 0,
        });
    }

    switchToUpload() {
        if (this.props.contentModalContent.imageId.length > 1) {
            this.switchToSizes();
        } else {
            this.props.actions.resetImageData();
            this.setState({
                cropperView: 0,
            });
        }
    }

    recropImage() {
        if (!this.props.crop.originalImage || !this.props.crop.originalImage.imagePath) {
            this.props.actions.getOriginalImageForCrop(this.props.match.params.projectId, constants.ImageType.find((n) => {
                return n.Name === 'ContentBanner';
            }).Id, this.props.contentModalContent.parentId);
        }

        this.props.actions.resetCroppedImage();
        this.switchToCrop();
    }

    deleteImage() {
        this.props.setStateFromEvent('', 'imageId');
        this.props.setStateFromEvent('', 'imageUrl');
        this.props.actions.resetImageData();
        this.setState({ cropperView: 0 });
    }

    render() {
        const cropperOrLoader = this.props.crop.modal === true
            ? (
                <ImageCropper
                    borderRadius={0}
                    color={[28, 30, 34, 0.75]}
                    cropperHeight={720}
                    cropperWidth={1280}
                    cropperBorder={160}
                    aspect={this.state.aspectRatio}
                    onClose={this.switchToUpload}
                    image={this.state.imageLocation}
                    imageName={this.state.file.name}
                    imageType={constants.ImageType.find((n) => {
                        return n.Name === 'ContentBanner';
                    }).Id}
                    isOriginal
                    originalHeight={this.state.originalHeight}
                    originalWidth={this.state.originalWidth}
                    switchToSizes={this.switchToSizes}
                    increaseMajorVersion={this.state.increaseMajorVersion}
                    projVersion={this.props.versions.select}
                    minWidth={constants.ImageType.find((n) => { return n.Name === 'ContentBanner'; }).MinWidth}
                    minHeight={constants.ImageType.find((n) => { return n.Name === 'ContentBanner'; }).MinHeight}
                />
            )
            : (
                <div id="loading-page">
                    <div id="loading-container_loader">
                        <LargeLoading />
                    </div>
                </div>
            );

        return (
            <div className="edit-banner-content">
                <span className="preview">{this.props.crop.modal === true ? 'Crop Your Photo' : 'Preview'}</span>
                {!this.props.crop.modal && this.state.cropperView === 0 && this.props.contentModalContent.imageId.length < 1
                    && <ImageDropZone hasError={this.state.hasError} alertView="pages-modal" imageType="ContentBanner" setFile={this.setFile} width="1280" height="720" />}
                {this.state.cropperView === 1 && cropperOrLoader}
                {this.state.cropperView === 2 && (
                    <div className="preview-display">
                        <div className="image-preview-wrapper">
                            <button
                                data-qa="banner-recrop-button"
                                type="button"
                                className="btn-design-system medium secondary icon}"
                                onClick={() => {
                                    this.recropImage();
                                }}
                            >
                                <FontAwesomeIcon icon={['far', 'crop-alt']} />
                            </button>
                            <button
                                data-qa="banner-delete-button"
                                type="button"
                                className="btn-design-system medium secondary icon}"
                                onClick={() => {
                                    this.deleteImage();
                                }}
                            >
                                <FontAwesomeIcon icon={['fas', 'trash']} />
                            </button>
                            <div className="preview-banner">
                                {/* eslint-disable-next-line eqeqeq */}
                                <div className={`overlay-banner ${this.props.contentModalContent.bannerOverlayColor == 2 ? 'light' : ''} ${this.props.contentModalContent.bannerOverlayColor == 3 ? 'medium' : ''} ${this.props.contentModalContent.bannerOverlayColor == 4 ? 'dark' : ''}`} />
                                <img
                                    alt="selected banner"
                                    width="100%"
                                    src={this.props.crop.croppedImage?.imagePath ? this.props.crop.croppedImage.imagePath : this.props.contentModalContent.imageUrl}
                                />
                            </div>
                            <div
                                className={`text-overlay ${this.props.contentModalContent.bannerTextColor === '#343434' ? 'dark' : ''}`}
                            >
                                {this.props.contentModalContent.bannerText}
                            </div>
                        </div>
                    </div>
                )}
                {this.state.cropperView !== 1
                    && (
                        <div>
                            <ValidatedInput
                                containerClass="input_Text"
                                labelText="Banner Text"
                                value={this.props.contentModalContent.bannerText}
                                name="bannerText"
                                onChange={(e) => {
                                    return this.props.setStateFromEvent(e, 'bannerText');
                                }}
                                errorMessage=""
                                hasError={false}
                                successMessage=""
                                hasSuccess={false}
                            />
                            <div className="banner-options">
                                <div className="banner-text-color-selectors">
                                    <h4>Banner Text Color</h4>
                                    <ColorRadio
                                        id="bannerTextColor-ffffff"
                                        name="bannerTextColor"
                                        handleClick={(e) => {
                                            return this.props.setStateFromEvent(e, 'bannerTextColor');
                                        }}
                                        defaultChecked={this.props.contentModalContent.bannerTextColor === '#ffffff'}
                                        value="#ffffff"
                                        displayColor="#ffffff"
                                    />

                                    <ColorRadio
                                        id="bannerTextColor-343434"
                                        name="bannerTextColor"
                                        handleClick={(e) => {
                                            return this.props.setStateFromEvent(e, 'bannerTextColor');
                                        }}
                                        defaultChecked={this.props.contentModalContent.bannerTextColor === '#343434'}
                                        value="#343434"
                                        displayColor="#343434"
                                    />
                                </div>
                                <div className="banner-overlay-selectors">
                                    <h4>Darken Image</h4>
                                    <ColorRadio
                                        id="bannerOverlayColor-1"
                                        name="bannerOverlayColor"
                                        handleClick={(e) => {
                                            return this.props.setStateFromEvent(e, 'bannerOverlayColor');
                                        }}
                                        defaultChecked={this.props.contentModalContent.bannerOverlayColor === 1}
                                        displayColor="#ffffff"
                                        value={1}
                                        rectangle
                                    />

                                    <ColorRadio
                                        id="bannerOverlayColor-2"
                                        name="bannerOverlayColor"
                                        handleClick={(e) => {
                                            return this.props.setStateFromEvent(e, 'bannerOverlayColor');
                                        }}
                                        defaultChecked={this.props.contentModalContent.bannerOverlayColor === 2}
                                        displayColor="#b0b0b2"
                                        value={2}
                                        rectangle
                                    />

                                    <ColorRadio
                                        id="bannerOverlayColor"
                                        name="bannerOverlayColor"
                                        handleClick={(e) => {
                                            return this.props.setStateFromEvent(e, 'bannerOverlayColor');
                                        }}
                                        defaultChecked={this.props.contentModalContent.bannerOverlayColor === 3}
                                        displayColor="#8e8f91"
                                        value={3}
                                        rectangle
                                    />

                                    <ColorRadio
                                        id="bannerOverlayColor-343434"
                                        name="bannerOverlayColor"
                                        handleClick={(e) => {
                                            return this.props.setStateFromEvent(e, 'bannerOverlayColor');
                                        }}
                                        defaultChecked={this.props.contentModalContent.bannerTextColor === 4}
                                        displayColor="#55575a"
                                        value={4}
                                        rectangle
                                    />
                                </div>

                                <div className="check-rec">
                                    <label
                                        data-qa="form-full-width-label"
                                        id="form-full-width__label"
                                    >
                                        <input
                                            data-qa="form-full-width-checkbox"
                                            id="form-full-width"
                                            defaultChecked={this.props.contentModalContent.isFullWidth}
                                            onChange={(e) => {
                                                return this.props.setStateFromEvent(e, 'isFullWidth');
                                            }}
                                            type="checkbox"
                                        />
                                        <span
                                            className={this.props.contentModalContent.isFullWidth === false ? 'checkbox-rec empty' : 'checkbox-rec checked'}
                                        />
                                        <span className="form-full-width">
                                            Extend image the full width of the screen
                                        </span>
                                    </label>
                                </div>

                                <TapTypeSelector
                                    updateTapTypeFromEvent={this.props.updateTapTypeFromEvent}
                                    contentModalContent={this.props.contentModalContent}
                                    formsObjects={this.props.formsObjects}
                                    formsItems={this.props.formsItems}
                                    pagesItems={this.props.pagesItems}
                                    setStateFromEvent={this.props.setStateFromEvent}
                                />
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BannerContentEditor));
